import { flow, forEach, reject, unary } from 'lodash/fp';
import getMelbourneTimezoneMoment from '@ahmdigital/logic/lib/utils/get-melbourne-timezone-moment';
// @ts-expect-error - Automatic, Please fix when editing this file
import isExpired from '@ahmdigital/offers/lib/model/offer/is-expired';

import { GET_ALL_OFFERS } from './queries.gql';
import logging from '../../../../logging';
import useOfferQuery from '../use-offer-query';
import validateOffer from '../validate-offer';

type UseGetAllOffersOptions = {
  skip?: boolean;
};

const useGetAllOffers = ({ skip = false }: UseGetAllOffersOptions = {}) => {
  const { data, error, loading } = useOfferQuery(GET_ALL_OFFERS, { skip });

  if (skip) {
    return { allOffers: [], loading: false };
  }

  const allOffers = data?.allOffer;

  if (!loading && error) {
    logging.getLogger().error('graphql::error - Failed to get offers from CMS', { error });
    return { allOffers: [], loading: false };
  }

  // Validate all offers but don't bother for offers that are out of date
  const now = getMelbourneTimezoneMoment();

  // eslint-disable-next-line lodash-fp/no-unused-result
  flow(
    reject((offer) => isExpired(offer, { effectiveDate: now })),
    forEach(unary(validateOffer)),
  )(allOffers);

  return { allOffers, loading };
};

export default useGetAllOffers;
